import React from 'react';
import Reflux from 'reflux';
import RcIf from 'rc-if';
import './SearchFull.css';
import ModalStore from '../stores/ModalStore';
import AppStore from '../AppStore';
import AppActions from '../AppActions';
import ModalActions from '../actions/ModalActions';
import history from '../history';
class SearchFull extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {
            query: ''
        };
        this.stores = [ModalStore, AppStore];
        AppActions.getTrendingTopics();
        AppActions.getLatestTopics();
        AppActions.getPopularUsers();
    }

    goToSearchPage = () => {
        history.push('/search/' + this.state.query);
    }

    goToSearch = (query) => {
        this.setState({ query }, () => { this.goToSearchPage(); });
    }

    stopPropagation = (event) => {
        if (event.stopPropagation) {
            event.stopPropagation();
        } else {
            event.cancelBubble = true;
        }
    }

    clickOutsideModal = () => {
        ModalActions.changeSearchModalStatus(false);
    }

    handleSearch = (event) => {
        this.setState({query: event.target.value});
    }
    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.goToSearchPage();
        }
    }
    filterLatestTopics = () => {
        let { latestTopics } = this.state;
        let topics = latestTopics.map((topic) => { return topic.title; });
        topics = topics.filter((item, index) => {
            return topics.indexOf(item) >= index;
        });
        return topics;
    }
    render () {
        let showModalSearch = this.state.searchAvailable ? 'showSearch' : '';
        let animationInputSearch = this.state.searchAvailable ? 'animation-input' : '';
        let animationOptionSearch = this.state.searchAvailable ? 'animation-search' : '';
        return (
          <RcIf if={this.state.isSearchModalShowing}>
            <div className={'search-full ' + (showModalSearch)}>
              <div onClick={this.clickOutsideModal} className='search-relative'>
                <a className='close-search'><i className='fa fa-times' /></a>
                <div onClick={this.stopPropagation} className='search-absolute'>
                  <div className='search-init'>
                    <div className='full-absolute'>
                      <div className={'search-box ' + (animationInputSearch)}>
                        <i className='fa fa-search' aria-hidden='true' />
                        <input placeholder='¿Qué estás buscando?' autoFocus type='text' className='relative' onChange={this.handleSearch} onKeyPress={this.handleKeyPress} />
                        <a className='btn-primary' onClick={this.goToSearchPage}>Buscar</a>
                      </div>
                      <div className='row in-mobile-hide'>
                        <ul className={'suggest-search ' + (animationOptionSearch)}>
                          <li className='col l4 m6 s12'>
                            <h6><i className='fa fa-angle-right' />Destacados</h6>
                            <div className='options'>
                              {
                                this.state.trendingTopics.map((topic, index) => {
                                    if (index <= 4) {
                                        return (<a key={topic._id} onClick={() => { this.goToSearch(topic.title); }}>{topic.title}</a>);
                                    }
                                })
                              }
                            </div>
                          </li>
                          <li className='col l4 m6 s12'>
                            <h6><i className='fa fa-angle-right' />Usuarios</h6>
                            <div className='options'>
                              {
                                this.state.popularUsers.map((user, index) => {
                                    if (index <= 4) {
                                        return (<a key={user._id} onClick={() => { this.goToSearch(user.name); }}>{user.name}</a>);
                                    }
                                })
                              }
                            </div>
                          </li>
                          <li className='col l4'>
                            <h6><i className='fa fa-angle-right' />Recientes</h6>
                            <div className='options'>
                              {
                                this.filterLatestTopics().map((topic, index) => {
                                    if (index <= 4) {
                                        return (<a key={index} onClick={() => { this.goToSearch(topic); }}>{topic}</a>);
                                    }
                                })
                              }
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </RcIf>
        );
    }
}
export default SearchFull;



// WEBPACK FOOTER //
// ./src/sections/SearchFull.js